import { Link } from "react-router-dom";
import { useCompany } from "@/lib/company";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { company } = useCompany();
  const { t } = useLang();
  return (
    <footer className="mt-24 bg-[#1A3322] text-white/90" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-11 h-11 rounded-full bg-white p-1 flex items-center justify-center">
              <img
                src="https://customer-assets-4nw71qhi.emergentagent.net/job_sukana-launch/artifacts/9b5fhq23_LOGO%20SUKACOOP.PNG"
                alt="SUKANACOOP"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="heading font-extrabold text-xl">SUKANACOOP</span>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            {t("footer.description")}
          </p>
        </div>
        <div>
          <p className="label-uppercase text-xs text-[#D98A2C] mb-4">{t("footer.marketplace")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/produits" className="hover:text-[#D98A2C]">{t("header.products")}</Link></li>
            <li><Link to="/services" className="hover:text-[#D98A2C]">{t("header.services")}</Link></li>
            <li><Link to="/boutiques" className="hover:text-[#D98A2C]" data-testid="footer-shops-link">{t("dir.header_link")}</Link></li>
            <li><Link to="/categories" className="hover:text-[#D98A2C]">{t("header.categories")}</Link></li>
            <li><Link to="/recherche" className="hover:text-[#D98A2C]">{t("footer.search")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-uppercase text-xs text-[#D98A2C] mb-4">{t("footer.sell")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/inscription/vendeur" className="hover:text-[#D98A2C]">{t("footer.becomeSeller")}</Link></li>
            <li><Link to="/vendeur" className="hover:text-[#D98A2C]">{t("footer.dashboard")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-uppercase text-xs text-[#D98A2C] mb-4">{t("footer.help_legal")}</p>
          <ul className="space-y-2 text-sm">
            {company?.email && <li><a href={`mailto:${company.email}`} className="hover:text-[#D98A2C]">{company.email}</a></li>}
            {company?.phone && <li><a href={`tel:${company.phone}`} className="hover:text-[#D98A2C]">{company.phone}</a></li>}
            <li><Link to="/mentions-legales" className="hover:text-[#D98A2C]" data-testid="footer-legal-link">{t("footer.legal")}</Link></li>
            <li><Link to="/cgv" className="hover:text-[#D98A2C]" data-testid="footer-cgv-link">{t("cgv.footer.link")}</Link></li>
            <li>
              <button
                type="button"
                onClick={() => window.dispatchEvent(new CustomEvent("sukana:open-cookie-settings"))}
                className="hover:text-[#D98A2C]"
                data-testid="footer-cookies-link"
              >
                {t("cookies.footer_link")}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
        © {new Date().getFullYear()} SUKANACOOP
      </div>
    </footer>
  );
}
